import { render } from "./SignupHeader.vue?vue&type=template&id=1510a8bf"
import script from "./SignupHeader.vue?vue&type=script&lang=js"
export * from "./SignupHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__